
import axios from "../../../services/axios-config.js";



export function getDashboardDetails(){
    return new Promise(async (resolve, reject) => {
        try{
            const res = await axios.get(`/admin/dashboard/info`);

            if(res.status == 200){
                return resolve(res.data);
            }

        } catch (e) {
            console.error('ERROR - GET DASHBOARD DETAILS FUNCTION:', e);
            reject (e);
        }
    })
}